import ApiService from '@/data/services/ApiService'
import { AxiosResponse } from 'axios'

export interface IEventTypeMeta {
  value: string;
  is_other: boolean;
  color: string;
  label: string;
}

export class EventTypeApiService extends ApiService {
  // Backend-served canonical event type list. `locale` returns translated labels.
  static async getAll(locale?: string): Promise<IEventTypeMeta[]> {
    return this.axios.get('event-types', { params: locale ? { locale } : {} })
      .then((response: AxiosResponse<IEventTypeMeta[]>) => response.data)
  }
}
